/*jshint esversion: 9 */
import React from "react";
import { connect } from "react-redux";
import { Fragment } from "react";
// import { withStyles } from "@material-ui/core/styles";
import {
  doLog,
  getAppOptions,
  hasValue,
  updateObject,
} from "../shared/utility";

import Button from "@material-ui/core/Button";
import Card from "../components/UI/Card/Card";
import classes from "./CrimeSubmission.css";
import * as actions from "../store/actions/index";
import { DataGrid } from "@mui/x-data-grid";
import { DEFAULT_GRID_OPTIONS } from "@material-ui/x-grid";
import Grid from "@material-ui/core/Grid";
import Form from "../components/UI/Form/Form";
import SectionHeading from "../components/UI/SectionHeading/SectionHeading";

const sectionName = "Vehicle";
const { rowHeight, headerHeight } = DEFAULT_GRID_OPTIONS;

const mappedSelectPropFields = [
  "vehicleInvolvement",
  "vehicleStateCode",
  // "vehicleBodyStyle",
  // "vehicleMake",
  // "vehicleColor1",
];

const mappedTextPropFields = [
  "vehicleDescription",
  "vehicleModel",
  "vehicleYear",
  "vehiclePlateTag",
  "vehicleVIN",
  "vehicleDamageValue",
  "vehicleInsuranceCompany",
  "vehiclePolicyHolder",
  "vehiclePolicyNumber",
  //
  "vehicleBodyStyle",
  "vehicleMake",
  "vehicleColor1",
  //
  "id",
  "deleted",
  "timsVehicleID",
  // search versions of fields:
  "vehiclePlateTagSearch",
  "vehicleStateCodeSearch",
  "vehicleMakeSearch",
  "vehicleModelSearch",
  "vehicleColor1Search",
  "vehicleVINSearch",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

// const gridSpacing = 8; //0 or 8 or 16 or 24 or 32 or 40

class Vehicle extends Form {
  state = {
    searching: false,
    editMode: true,
    itemProcessed: false,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    sectionName: sectionName,
    runTIMSSearch: false,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    vehicleInvolvement: {
      inputType: "select",
      labelValue: null,
      value: null,
      label: "Involvement Type",
      listName: "vehicleInvolvementList",
      codegroup: "164",
      validation: { required: true },
    },
    vehicleDescription: {
      inputType: "text",
      value: "",
      label: "Vehicle Description",
      validation: { required: true },
    },
    vehicleYear: { inputType: "number", value: "", label: "Model Year" },
    vehiclePlateTag: {
      inputType: "text",
      value: "",
      label: "License Plate #",
      upperOnly: true,
      validation: { required: true },
    },
    vehicleStateCode: {
      inputType: "select",
      labelValue: null,
      value: "MI",
      label: "Licensing State",
      listName: "stateList",
      codegroup: "162",
      validation: { required: true },
    },
    vehicleVIN: { inputType: "text", value: "", upperOnly: true, label: "VIN" },
    // vehicleBodyStyle: {
    //   inputType: "select",
    //   labelValue: null,
    //   value: null,
    //   label: "Body Style",
    //   listName: "vehicleBodyStyleList",
    //   codegroup: "17",
    // },
    vehicleBodyStyle: {
      inputType: "text",
      value: null,
      label: "Body Style",
      upperOnly: true,
    },
    // vehicleMake: {
    //   inputType: "select",
    //   labelValue: null,
    //   value: null,
    //   label: "Make",
    //   listName: "vehicleMakeList",
    //   codegroup: "160",
    //   validation: { required: true },
    // },
    vehicleMake: {
      inputType: "test",
      value: null,
      label: "Make",
      upperOnly: true,
      validation: { required: true },
    },
    vehicleModel: {
      inputType: "text",
      value: null,
      label: "Model",
      upperOnly: true,
      validation: { required: false },
    },
    // vehicleColor1: {
    //   inputType: "select",
    //   labelValue: null,
    //   value: null,
    //   label: "Color",
    //   listName: "vehicleColorList",
    //   codegroup: "161",
    // },
    vehicleColor1: {
      inputType: "text",
      value: null,
      label: "Color",
      upperOnly: true,
    },
    vehicleDamageValue: {
      inputType: "number",
      value: "",
      label: "Damaged Value ($)",
    },
    vehicleInsuranceCompany: {
      inputType: "text",
      value: "",
      label: "Insurance Company",
    },
    vehiclePolicyHolder: {
      inputType: "text",
      value: "",
      label: "Insurance Policy Holder",
    },
    vehiclePolicyNumber: {
      inputType: "text",
      value: "",
      label: "Insurance Policy #",
    },
    //
    id: {
      inputType: "text",
      value: "-1",
      label: "ID",
      validation: { required: false },
    },
    deleted: {
      inputType: "text",
      value: "",
      label: "Deleted",
      validation: { required: false },
    },
    //
    vehiclePlateTagSearch: {
      inputType: "text",
      value: "",
      label: "License Plate #",
      upperOnly: true,
      validation: { required: true },
    },
    vehicleStateCodeSearch: {
      inputType: "select",
      labelValue: null,
      value: "MI",
      label: "Licensing State",
      listName: "stateList",
      codegroup: "162",
      validation: { required: true },
    },
    vehicleMakeSearch: {
      inputType: "text",
      value: null,
      label: "Make",
      upperOnly: true,
      validation: { required: true },
    },
    vehicleModelSearch: {
      inputType: "text",
      value: null,
      label: "Model",
      upperOnly: true,
      validation: { required: false },
    },
    // vehicleColor1Search: {
    //   inputType: "select",
    //   labelValue: null,
    //   value: null,
    //   label: "Color",
    //   listName: "vehicleColorList",
    //   codegroup: "161",
    // },
    vehicleColor1Search: {
      inputType: "text",
      value: null,
      label: "Color",
      upperOnly: true,
    },
    vehicleVINSearch: {
      inputType: "text",
      value: "",
      upperOnly: true,
      label: "VIN",
    },
    //
    timsSearch: {
      inputType: "checkbox",
      value: "N",
      default: "N",
      label: "Search in TIMS: (Optional)",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
  };

  addNewVehicleItem() {
    const newInstance = this.props.vehicleArray.length;
    const vehicleFields = null;
    const vehicleItem = {
      vehicleInstance: newInstance,
      vehicleFields: vehicleFields,
    };

    if (doLog())
      console.log("[Vehicle] addNewVehicleItem vehicleItem:", vehicleItem);
    this.props.onAddToVehicleArray(this.props.vehicleArray, vehicleItem);
  }

  checkAndLoadConfig() {
    if (this.props.configuration !== null) {
      if (doLog())
        console.log(
          "[Vehicle]checkAndLoadConfig ciddbConnectionName:",
          this.props.configuration.ciddbConnectionName
        );
      if (
        this.props.configuration !== null &&
        this.props.configuration.ciddbConnectionName !== null
      ) {
        if (this.props.vehicleSelectFieldList === null) {
          this.props.onSetVehicleSelectFieldList(mappedSelectPropFields);
        } else if (this.props.vehicleTextFieldList === null) {
          this.props.onSetVehicleTextFieldList(mappedTextPropFields);
        }
      }
    }
  }

  componentDidMount() {
    if (doLog()) console.log("[Vehicle] componentDidMount state:", this.state);
    if (doLog()) console.log("[Vehicle] componentDidMount props:", this.props);
    this.checkAndLoadConfig();
    this.setFieldRequiredSettings();
  }

  componentDidUpdate() {
    if (doLog()) console.log("[Vehicle] componentDidUpdate state:", this.state);
    if (doLog()) console.log("[Vehicle] componentDidUpdate props:", this.props);
    this.checkAndLoadConfig();
    this.copyFieldValuesToState();
  }

  copyFieldValuesToState() {
    if (!this.state.itemProcessed) {
      if (doLog())
        console.log("[Vehicle] copyFieldValuesToState item:", this.props.item);
      if (this.props.item !== null && this.props.item.vehicleFields !== null) {
        const vehicleFields = this.props.item.vehicleFields;

        for (let field in this.state.mappedTextPropFields) {
          const fieldName = this.state.mappedTextPropFields[field];
          if (doLog())
            console.log(
              "[Vehicle] copyFieldValuesToState text field:",
              fieldName
            );
          if (
            hasValue(vehicleFields[fieldName]) &&
            hasValue(vehicleFields[fieldName].value)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                value: vehicleFields[fieldName].value,
              }),
            });
          }
        }

        for (let field in this.state.mappedSelectPropFields) {
          const fieldName = this.state.mappedSelectPropFields[field];
          if (doLog())
            console.log(
              "[Vehicle] copyFieldValuesToState select field:",
              fieldName
            );
          if (
            hasValue(vehicleFields[fieldName]) &&
            hasValue(vehicleFields[fieldName].value)
          ) {
            this.setState({
              [fieldName]: updateObject(this.state[fieldName], {
                value: vehicleFields[fieldName].value,
              }),
            });
          }
        }
      }
      this.setState({ itemProcessed: true });
    }
  }

  handleAddButton = () => {
    if (doLog()) console.log("[Vehicle]handleAddButton");
    this.addNewVehicleItem();
  };

  handleDeleteButton = () => {
    if (doLog()) console.log("[Vehicle] handleDeleteButton");
    const vehicleItem = this.props.item;

    if (doLog())
      console.log("[Vehicle] handleDeleteButton vehicleItem:", vehicleItem);
    if (
      hasValue(vehicleItem.vehicleFields) &&
      hasValue(vehicleItem.vehicleFields.id) &&
      hasValue(vehicleItem.vehicleFields.id.value) &&
      vehicleItem.vehicleFields.id.value !== "-1"
    ) {
      if (doLog())
        console.log("[Vehicle] handleDeleteButton setting deleted to Y");
      this.setState({
        deleted: updateObject(this.state.deleted, {
          value: "Y",
        }),
      });
      //update the vehicleArray so that this change doesn't get overridden in copyFieldValuesToState()
      const newVehicleArray = [];
      const length = this.props.vehicleArray.length;
      for (let i = 0; i < length; i++) {
        let vehicleFields = null;
        const item = this.props.vehicleArray[i];
        if (doLog())
          console.log("[Vehicle] handleDeleteButton item[" + i + "]:", item);
        if (item === vehicleItem) item.vehicleFields.deleted.value = "Y";
        vehicleFields = item.vehicleFields;
        console.log(
          "[Vehicle] handleDeleteButton vehicleFields:",
          vehicleFields
        );
        newVehicleArray.push({
          vehicleFields: vehicleFields,
          vehicleInstance: i,
        });
        this.props.onSetVehicleArray(newVehicleArray);
      }
    } else {
      this.props.onDeleteFromVehicleArray(this.props.vehicleArray, vehicleItem);
    }
  };

  handleRowClick = (param, event) => {
    if (doLog()) console.log("[Vehicle] handleRowClick param:", param);
    if (doLog()) console.log("[Vehicle] handleRowClick event:", event);
    if (param != null && param.row != null) {
      const array = this.props.result.RESULT.VEHICLE;
      const row = param.row;
      let item = null;
      if (hasValue(array.length)) item = array[row.id];
      else item = array;
      if (doLog()) console.log("[Vehicle] handleRowClick item:", item);
      let description = "";
      if (hasValue(item.VEHICLEYEAR) && item.VEHICLEYEAR.length > 0) {
        description += item.VEHICLEYEAR + " ";
      }
      if (hasValue(item.COLOR1) && item.COLOR1.length > 0) {
        description += item.COLOR1 + " ";
      }
      if (hasValue(item.MAKE) && item.MAKE.length > 0) {
        description += item.MAKE + " ";
      }
      if (hasValue(item.MODEL) && item.MODEL.length > 0) {
        description += item.MODEL + " ";
      }

      this.setState({
        vehicleDescription: updateObject(this.state.vehicleDescription, {
          value: description,
        }),
        vehicleYear: updateObject(this.state.vehicleYear, {
          value: item.VEHICLEYEAR,
        }),
        vehiclePlateTag: updateObject(this.state.vehiclePlateTag, {
          value: item.PLATETAG,
        }),
        vehicleStateCode: updateObject(this.state.vehicleStateCode, {
          value: item.STATECODE,
        }),
        vehicleVIN: updateObject(this.state.vehicleVIN, {
          value: item.VIN,
        }),
        vehicleBodyStyle: updateObject(this.state.vehicleBodyStyle, {
          value: item.BODYSTYLE,
        }),
        vehicleMake: updateObject(this.state.vehicleMake, {
          value: item.MAKE,
        }),
        vehicleModel: updateObject(this.state.vehicleModel, {
          value: item.MODEL,
        }),
        vehicleColor1: updateObject(this.state.vehicleColor1, {
          value: item.COLOR1,
        }),
        timsVehicleID: updateObject(this.state.timsVehicleID, {
          value: item.VEHICLEID,
        }),
      });
    }
  };

  handleSearchTIMS = () => {
    if (doLog()) console.log("[Vehicle] handleSearchTIMS");
    this.setState({ runTIMSSearch: true });
    this.props.onClearTransactionResult();
    this.props.onClearTransDesc();
    let transactionType =
      '<CIDDB><QUERY TABLE="Vehicle" LIMIT="100">' +
      "  <FIELD_LIST>ALL</FIELD_LIST>" +
      "  <WHERE>";
    if (hasValue(this.state.vehiclePlateTagSearch.value))
      transactionType +=
        '    <PLATETAG SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.vehiclePlateTagSearch.value +
        "</SEARCH_VALUE>" +
        "    </PLATETAG>";
    if (hasValue(this.state.vehicleStateCodeSearch.value))
      transactionType +=
        '    <STATECODE SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.vehicleStateCodeSearch.value +
        "</SEARCH_VALUE>" +
        "    </STATECODE>";
    if (hasValue(this.state.vehicleMakeSearch.value))
      transactionType +=
        '    <MAKE SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.vehicleMakeSearch.value.toUpperCase() +
        "</SEARCH_VALUE>" +
        "    </MAKE>";
    if (hasValue(this.state.vehicleModelSearch.value))
      transactionType +=
        '    <MODEL SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.vehicleModelSearch.value +
        "</SEARCH_VALUE>" +
        "    </MODEL>";
    if (hasValue(this.state.vehicleColor1Search.value))
      transactionType +=
        '    <COLOR1 SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.vehicleColor1Search.value +
        "</SEARCH_VALUE>" +
        "    </COLOR1>";
    if (hasValue(this.state.vehicleVINSearch.value))
      transactionType +=
        '    <VIN SEARCH_TYPE="equal_to">' +
        "      <SEARCH_VALUE>" +
        this.state.vehicleVINSearch.value +
        "</SEARCH_VALUE>" +
        "    </VIN>";
    transactionType +=
      "  </WHERE>" +
      "  <ORDER_BY>" +
      "    <VehiclePlateTag/>" +
      "    <VehicleMake/>" +
      "    <VehicleModel/>" +
      "    <vehicleColor1/>" +
      "  </ORDER_BY>" +
      "</QUERY></CIDDB>";
    const data = {};
    const request = {
      transactionType,
      data,
    };
    this.props.onRunTransaction(request, this.props.token, "NameList");
  };

  setFieldRequiredSettings() {
    for (let field in this.state.mappedTextPropFields) {
      const fieldName = this.state.mappedTextPropFields[field];
      const required = this.getFieldRequiredStatus(fieldName, sectionName);
      const requiredOption = { required: required };
      // if (doLog()) console.log("[Vehicle]setFieldRequiredSettings text field:", fieldName);
      // if (doLog()) console.log("[Vehicle]setFieldRequiredSettings required:", required);
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          validation: requiredOption,
        }),
      });
    }

    for (let field in this.state.mappedSelectPropFields) {
      const fieldName = this.state.mappedSelectPropFields[field];
      const required = this.getFieldRequiredStatus(fieldName, sectionName);
      const requiredOption = { required: required };
      // if (doLog()) console.log("[Vehicle]setFieldRequiredSettings select field:", fieldName);
      // if (doLog()) console.log("[Vehicle]setFieldRequiredSettings select required:", required);
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          validation: requiredOption,
        }),
      });
    }
  }

  render() {
    if (doLog())
      console.log(
        "[Vehicle] render vehicleInstance:",
        this.props.item.vehicleInstance
      );

    let informationSection = null;
    if (this.props.item.vehicleInstance === 0) {
      informationSection = (
        <Grid item xs={12}>
          <p className={classes.Information}>
            Next, please enter information about the vehicle(s) involved in the
            incident.
          </p>
        </Grid>
      );
    }

    let searchResults = null;
    let listRows = [];
    if (
      hasValue(this.props.result !== null) &&
      hasValue(this.props.result.RESULT) &&
      hasValue(this.props.result.RESULT.VEHICLE)
    ) {
      const array = this.props.result.RESULT.VEHICLE;
      if (doLog()) console.log("[Vehicle] render array:", array);
      if (doLog()) console.log("[Vehicle] render array length:", array.length);
      if (array !== null) {
        if (hasValue(array.length)) {
          for (let i = 0; i < array.length; i++) {
            const fields = array[i];
            listRows.push({
              id: i,
              PLATE: fields.PLATETAG,
              STATECODE: fields.STATECODE,
              YEAR: fields.VEHICLEYEAR,
              MAKE: fields.MAKE,
              MODEL: fields.MODEL,
              COLOR: fields.COLOR1,
              VIN: fields.VIN,
            });
          }
        } else {
          const fields = array;
          listRows.push({
            id: 1,
            PLATE: fields.PLATETAG,
            STATECODE: fields.STATECODE,
            YEAR: fields.VEHICLEYEAR,
            MAKE: fields.MAKE,
            MODEL: fields.MODEL,
            COLOR: fields.COLOR1,
            VIN: fields.VIN,
          });
      }
      }
    }

    const listColumns = [
      {
        field: "PLATE",
        renderHeader: (params) => <strong>{"Plate"}</strong>,
        width: 100,
      },
      {
        field: "STATECODE",
        renderHeader: (params) => <strong>{"State"}</strong>,
        width: 30,
      },
      {
        field: "YEAR",
        renderHeader: (params) => <strong>{"Year"}</strong>,
        width: 70,
      },
      {
        field: "MAKE",
        renderHeader: (params) => <strong>{"Make"}</strong>,
        width: 130,
      },
      {
        field: "MODEL",
        renderHeader: (params) => <strong>{"Model"}</strong>,
        width: 130,
      },
      {
        field: "COLOR",
        renderHeader: (params) => <strong>{"Color"}</strong>,
        width: 100,
      },
      {
        field: "VIN",
        renderHeader: (params) => <strong>{"VIN"}</strong>,
        width: 130,
      },
    ];

    const optionSelect = (
      <Fragment>
        <Grid item xs={12}>
          <div style={{ height: headerHeight + rowHeight * 4 }}>
            <DataGrid
              rows={listRows}
              columns={listColumns}
              onRowClick={this.handleRowClick}
              getRowHeight={() => "auto"}
            />
          </div>
        </Grid>
      </Fragment>
    );

    searchResults = <Fragment>{optionSelect}</Fragment>;

    let searchOptionSection = null;
    let searchSection = null;
    let permitted = false;
    const appOptions = getAppOptions();
    if (doLog()) console.log("[Vehicle] appOptions:", appOptions);
    const permissionOption = appOptions["fbr"];
    if (
      hasValue(permissionOption) &&
      permissionOption.toUpperCase().startsWith("T")
    ) {
      permitted = true;
    }
    if (doLog()) console.log("[Vehicle] permitted:", permitted);
    if (permitted) {
      searchOptionSection = (
        <Grid item xs={12}>
          {this.getFormField("timsSearch", false, true)}
        </Grid>
      );

      if (this.state.timsSearch.value === "Y") {
        searchSection = (
          <Fragment>
            <Grid item xs={12}>
              <p>Search in TIMS: (Optional)</p>
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("vehiclePlateTagSearch", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("vehicleStateCodeSearch", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("vehicleVINSearch", false, true)}
            </Grid>
            <Grid item xs={3} />
            <Grid item xs={3}>
              {this.getFormField("vehicleMakeSearch", false, true)}
            </Grid>
            <Grid item xs={3}>
              {this.getFormField("vehicleModelSearch", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleColor1Search", false, true)}
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleSearchTIMS.bind(this)}
              >
                Search
              </Button>
            </Grid>
            {searchResults}
            <Grid item xs={12}>
              <hr />
            </Grid>
          </Fragment>
        );
      }
    }

    let mainSection = null;
    if (this.state.deleted.value !== "Y") {
      mainSection = (
        <Card>
          <Grid container item className={classes.Card}>
            <SectionHeading sectionTitle="Vehicle Details" />
            {informationSection}
            <Grid item xs={12}>
              <hr />
            </Grid>
            {searchOptionSection}
            {searchSection}
            <Grid item xs={12}>
              {this.getFormField("vehicleDescription", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleInvolvement", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleMake", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleModel", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleBodyStyle", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleColor1", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleYear", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehiclePlateTag", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleStateCode", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleVIN", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehicleInsuranceCompany", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehiclePolicyNumber", false, true)}
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("vehiclePolicyHolder", false, true)}
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleAddButton.bind(this)}
              >
                Add another
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleDeleteButton.bind(this)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={6}></Grid>
          </Grid>
        </Card>
      );
    }

    return mainSection;
  }
}

const mapStateToProps = (state) => {
  // if (doLog()) console.log('Vehicle.mapStateToProps token:', state.auth.token);
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    result: state.trans.result,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    configuration: state.trans.configuration,
    //
    vehicleInvolvementList: state.trans.vehicleInvolvementList,
    vehicleBodyStyleList: state.trans.vehicleBodyStyleList,
    vehicleMakeList: state.trans.vehicleMakeList,
    vehicleColorList: state.trans.vehicleColorList,
    //
    stateList: state.trans.stateList,
    //
    vehicleArray: state.trans.vehicleArray,
    vehicleSelectFieldList: state.trans.vehicleSelectFieldList,
    vehicleTextFieldList: state.trans.vehicleTextFieldList,
    //
    selectedIncidentTypeData: state.trans.selectedIncidentTypeData,
    customTextList: state.trans.customTextList,
    requiredFieldList: state.trans.requiredFieldList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchValidCodeLists: (ori, token, listName, codeGroup) =>
      dispatch(actions.fetchValidCodeLists(ori, token, listName, codeGroup)),
    onAddToVehicleArray: (vehicleArray, vehicleItem) =>
      dispatch(actions.addToVehicleArray(vehicleArray, vehicleItem)),
    onDeleteFromVehicleArray: (vehicleArray, vehicleItem) =>
      dispatch(actions.deleteFromVehicleArray(vehicleArray, vehicleItem)),
    onSetVehicleArray: (vehicleArray) =>
      dispatch(actions.setVehicleArray(vehicleArray)),
    onSetVehicleSelectFieldList: (fieldList) =>
      dispatch(actions.setVehicleSelectFieldList(fieldList)),
    onSetVehicleTextFieldList: (fieldList) =>
      dispatch(actions.setVehicleTextFieldList(fieldList)),
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearTransDesc: () => dispatch(actions.clearTransDesc()),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(Vehicle)
// );
export default connect(mapStateToProps, mapDispatchToProps)(Vehicle);
